import { Redirect, Route, Switch } from 'react-router-dom';
import { RouteUrls } from './RouteUrls';
import { RoutePrivate } from './RoutePrivate';
import { WorkstationLanding } from '../Components/WorkstationLanding/WorkstationLanding';
import React from 'react';
import Login from '../Components/Login/Login';
import Logout from '../Components/Logout/Logout';
import AppLayout from '../Components/AppLayout/AppLayout';
import { BRANDS } from '../Themes/Branding';
import AdvancedConfiguration from '../Components/AdvancedConfiguration/AdvancedConfigurationController';
import Signup from '../Components/Signup/Signup';

export interface IRoutesProps {}

export const Routes: React.FC<IRoutesProps> = (props) => (
    <Switch>
        <Route
            render={() => (
                <AppLayout>
                    <Switch>
                        <Redirect exact from='/' to={RouteUrls.Login} />
                        <Redirect exact from={`${RouteUrls.Login}#s=1`} to={RouteUrls.Login} />
                        <Route exact path={RouteUrls.Logout} component={Logout} />
                        <Route exact path={RouteUrls.Login} component={Login} />
                    </Switch>
                    {process.env.REACT_APP_BRANDING === BRANDS.Atelier && (
                        <Switch>
                            <Route exact path={RouteUrls.Signup} component={Signup} />
                        </Switch>
                    )}
                    <Switch>
                        <RoutePrivate exact path={RouteUrls.WorkRemoteLanding}>
                            <WorkstationLanding />
                        </RoutePrivate>
                        {process.env.REACT_APP_BRANDING === BRANDS.Atelier && (
                            <Switch>
                                <RoutePrivate exact path={RouteUrls.AdvancedConfiguration}>
                                    <AdvancedConfiguration />
                                </RoutePrivate>
                            </Switch>
                        )}
                    </Switch>
                </AppLayout>
            )}
        />
    </Switch>
);
